import { FormWrapper } from '@app/features/form/Components/FormWrapper/FormWrapper';
import type { InventoryItem } from '../../types';
import { useInventoryFormConfig } from './form.config';

type Props = {
  data?: InventoryItem;
  onSubmit: (formData: InventoryItem) => Promise<void>;
  /** Label for the submit button; the drawer host knows whether this is a create or an edit. */
  submitLabel?: string;
  /** Root className override; pass "" when hosting inside a modal to drop the default full-screen height. */
  extraClasses?: string;
};

export function InventoryForm({ data, onSubmit, submitLabel, extraClasses }: Props) {
  const inventoryFormConfig = useInventoryFormConfig();
  // New items default to consumable so the "at least one capability" rule starts satisfied.
  const defaultValues = data ?? { isConsumable: true, isSellable: false, isRentable: false };

  return (
    <FormWrapper<InventoryItem>
      defaultValues={defaultValues}
      fields={inventoryFormConfig}
      onSubmit={onSubmit}
      {...(submitLabel !== undefined ? { submitLabel } : {})}
      {...(extraClasses !== undefined ? { extraClasses } : {})}
    />
  );
}
